import Store from './base';


export default class MemberResponseRateStore extends Store {
  constructor() {
    super('member-response-rates');
    this.state = {
      memberResponseRates: {},
    };
  }

  get(): Record<any, any> {
    return this.state.memberResponseRates;
  }
}
